module.exports = __webpack_public_path__ + "static/full2-12e1e3b8036a9c402de5143205aff671.png";